import FeedbackTrigger from 'records/FeedbackTrigger';
import CallTrigger from 'records/CallTrigger';
import {PERMISSION_TYPES} from './TriggerPermission';
import {Record, Map, List} from 'immutable';
import {TagInfo} from 'records/TagInfo';
import {Data, Int, RecordProps} from '@store/@types/util';
import {UserId} from 'records/User';

// A special object that gives a summary of role permissions for current user
const RulePermissionsSummary = Record(
  PERMISSION_TYPES.reduce((def, type) => ({...def, [type.value]: undefined}), {})
);

type TriggerRuleInfoId = Int;
interface TriggerRuleInfoInterface {
  id: TriggerRuleInfoId;
  name: string;
  context: FeedbackTrigger | CallTrigger;
  userId: UserId;
  // Map<ActionId, Action>
  actions: Map<unknown, unknown>;
  active: boolean;
  dampingDelay: Int;
  // rule.rulePermissions.EDIT === true;  Indicates the permission was granted directly to the user.
  // rule.rulePermissions.EDIT === false; Indicates the permission was granted in-directly (via team or department)
  // rule.rulePermissions.EDIT === undefined; Indicates the permission does not exist.
  // rule.rulePermissions.EDIT !== undefined; the correct way to test for existence of the permission
  rulePermissions: ReturnType<typeof RulePermissionsSummary>;
  antiRule: unknown;
  trends: Map<unknown, unknown>;
  actionNames: List<unknown>;
  tags: List<TagInfo>;
  shared: boolean;
  trendDescription: string;
}

export default class TriggerRuleInfo extends Data<TriggerRuleInfoInterface>({
  id: null,
  name: null,
  context: null,
  userId: null,
  // Map<ActionId, Action>
  actions: Map(),
  active: true,
  dampingDelay: 0,
  // rule.rulePermissions.EDIT === true;  Indicates the permission was granted directly to the user.
  // rule.rulePermissions.EDIT === false; Indicates the permission was granted in-directly (via team or department)
  // rule.rulePermissions.EDIT === undefined; Indicates the permission does not exist.
  // rule.rulePermissions.EDIT !== undefined; the correct way to test for existence of the permission
  rulePermissions: undefined,
  antiRule: null,
  trends: Map(),
  actionNames: List(),
  tags: List(),
  shared: null,
  trendDescription: null,
}) {
  static getTriggerContext(context) {
    if (context && context.type === 'feedback_trigger') {
      return new FeedbackTrigger(context);
    }
    if (context && context.type === 'call_trigger') {
      return new CallTrigger(context);
    }
  }

  constructor(props: RecordProps<TriggerRuleInfoInterface> = {}) {
    const tags: List<TagInfo> = props.tags ? List(props.tags.map(tag => new TagInfo(tag))) : List();
    super({
      ...props,
      context: TriggerRuleInfo.getTriggerContext(props.context),
      rulePermissions: new RulePermissionsSummary(props.rulePermissions),
      tags,
    });
  }

  getUserIds() {
    if ('getUserIds' in this.context) {
      return this.context.getUserIds();
    }
  }
}
